import { useNavigate } from "react-router-dom";
import { AiOutlineLogout } from "react-icons/ai";
import { toast } from "react-toastify";
import { useGetUserByIdQuery } from "../../Redux/auth/authApis";
import { useLogoutMutation } from "../../Redux/auth/authApis";
import { useAuth } from "../../hooks/useAuth";

const Navbar = () => {
  const { userId } = useAuth();
  const navigate = useNavigate();
  const { data: userData } = useGetUserByIdQuery(userId);
  const [logout] = useLogoutMutation();
  const profile = userData?.data?.photo
    ? userData?.data?.photo
    : "https://www.w3schools.com/howto/img_avatar.png";

  const handleClick = () => {
    navigate("/home");
  };

  const handleLogout = async () => {
    try {
      await logout().unwrap();
      toast.success("Logged out successfully", {
        position: "top-center",
        autoClose: 3000,
      });
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      toast.error("Logout failed. Please try again.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <nav
      className="text-white shadow-md"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, #E50914  , #E50914 20%, #FFD700 100%)",
      }}
    >
      <div className="w-full px-4 py-3 flex items-center justify-between lg:justify-center">
        <div
          className="navbar-logo cursor-pointer flex-shrink-0"
          onClick={handleClick}
        >
          <img
            src="https://www.certvalue.com/wp-content/uploads/2022/08/Untitled-design14.gif"
            alt="Dummy Logo"
            height="80px"
            width="200px"
            className="w-[120px] sm:w-[150px] md:w-[180px] lg:w-[200px] h-auto mix-blend-multiply"
          />
        </div>

        {/* Profile and Logout Button */}
        <div className="ml-auto flex items-center lg:absolute lg:right-4">
          {/* Profile Image */}
          <img
            src={profile}
            alt="Profile"
            className="w-[30px] h-[30px] md:w-[40px] md:h-[40px] rounded-full border-2 border-white"
          />
          <button
            onClick={handleLogout}
            className="flex items-center ml-1 text-sm md:text-base text-white bg-red-600 hover:bg-red-700 px-2 md:px-4 py-1 rounded-md"
          >
            <AiOutlineLogout className="text-lg md:text-xl" />
            <span className="hidden md:inline ml-2">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
